import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCe6dw27zIitZ2uDxUm-XoO4TTT1uwwnvQ",
  authDomain: "deadringers",
  projectId: "deadringers-e7651",
  appId: "606136115303"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
